import PrimaryTitle from './PrimaryTitle';

export default PrimaryTitle;
